import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import { ApiResponse, handleAxiosError } from "./responses/AxiosResponseHandler";

interface JoinVipUpdatePayload {
  groupId: string;
}

class JoinVipUpdateApi {
  private authClient: AuthClient;

  constructor(authClient: AuthClient) {
    this.authClient = authClient;
  }

  public async updateJoinVip(groupId: string): Promise<ApiResponse<void> | undefined> {
    try {
      const authenticationResponse = this.authClient.getAuthenticationResponse();
      if (!authenticationResponse) {
        return undefined;
      }

      const payload: JoinVipUpdatePayload = {
        groupId,
      };

      const response = await axios.put(
        `${this.authClient.getApiRoot()}/groups/myparties/${groupId}/joinvipupdate`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${authenticationResponse.token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
      };
    } catch (error) {
      const errorResponse = handleAxiosError<void>(error as AxiosError);
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data,
      };
    }
  }
}

export default JoinVipUpdateApi;
